import React from 'react';
import {
  Card,
  Avatar,
  PresenceDot,
  CardBody,
  CardTop,
  CardName,
  CardTime,
  CardPreview,
  UnreadPill,
} from './styles';
import { initialsOf, compactTime, previewOf, dirFor, avatarColor } from './helpers';

const ConversationCardV2 = ({ conversation, active, onClick }) => {
  const { user, lastMessage, unreadMessageCount, otherMemberPresence } = conversation;
  const preview = previewOf(lastMessage);
  const online = otherMemberPresence === 'online';
  const c = avatarColor(user?.id || user?.name);

  return (
    <Card active={active} onClick={onClick}>
      <Avatar src={user?.avatar} bg={c.bg} fg={c.fg} size="4.8rem">
        {!user?.avatar && initialsOf(user?.name)}
        {!conversation.isGroup && <PresenceDot online={online} />}
      </Avatar>
      <CardBody>
        <CardTop>
          <CardName>{user?.name || 'Conversation'}</CardName>
          <CardTime>{compactTime(lastMessage?.sentAt)}</CardTime>
        </CardTop>
        <CardTop>
          <CardPreview unread={unreadMessageCount > 0} dir={dirFor(preview)}>
            {preview}
          </CardPreview>
          {unreadMessageCount > 0 && (
            <UnreadPill>{unreadMessageCount > 99 ? '99+' : unreadMessageCount}</UnreadPill>
          )}
        </CardTop>
      </CardBody>
    </Card>
  );
};

export default ConversationCardV2;
